import { Injectable } from '@angular/core';
import { Token } from '@interfaces/core/token.interface';
import { TokenRefreshHandler } from '@services/token-refresh-handler.service';
import { Subscription } from 'rxjs';

import { AuthSessionDeleter } from './auth-user-session-deleter.service';

@Injectable({
  providedIn: 'root',
})
export class TokenRefresher {
  protected refreshTokenSubscription: Subscription;

  constructor(
    private readonly authSessionDeleter: AuthSessionDeleter,
    private readonly tokenRefreshHandler: TokenRefreshHandler,
  ) {}

  public listenTokenRefresh(tokens: Token): void {
    this.tokenRefreshHandler.run(tokens, 5);
    const refreshTokenObservable =
      this.tokenRefreshHandler.getRefreshTokenPeriodObservable();

    if (refreshTokenObservable) {
      this.refreshTokenSubscription = refreshTokenObservable.subscribe({
        next: () => {
          this.authSessionDeleter.run();
        },
      });
    }
  }
}
